import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import React from 'react';

const ItemTypeSelect = ({ label, helperText, errorText, fullWidth, value, onChange, itemTypes, ...other }) => {
  return (<FormControl error fullWidth={fullWidth}>
    <InputLabel htmlFor="name-error">{label}</InputLabel>
    <Select
      value={value && value.id ? value.id : value}
      onChange={(evt) => {
        console.log('id', evt.target.value);
        onChange(itemTypes.find((it) => it.id === evt.target.value));
      }}
      name={label}
    >
      {itemTypes.map((it) => {
        return (<MenuItem key={it.id} value={it.id}>{it.name}</MenuItem>);
      })}
    </Select>
    {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    {errorText ? <FormHelperText>{errorText}</FormHelperText> : null}
  </FormControl>);
};

export default ItemTypeSelect;



// WEBPACK FOOTER //
// ./src/components/Common/ItemTypeSelect/index.js